import { getMainAppDomain } from '../../utils/base-url';
import { Cookies } from '../cookies';

const LOCAL_STORAGE_KEYS = {
  ORIGINAL_USER_ID: 'originalUserId',
} as const;

export class UserImpersonation {
  /**
   * 
   * @param originalUserId Id of user who impersonates another user
   * @param impersonatedPortalId Id of the portal user impersonates to
   */
  static setImpersonationData(originalUserId: number) {
    window.localStorage.setItem(LOCAL_STORAGE_KEYS.ORIGINAL_USER_ID, originalUserId.toString());
  }

  static getImpersonationData() {
    const originalUserId = window.localStorage.getItem(LOCAL_STORAGE_KEYS.ORIGINAL_USER_ID);

    if (!originalUserId) return null;

    return {
      originalUserId: originalUserId ? parseInt(originalUserId, 10) : null,
    };
  }

  static setImpersonationDataToCookies() {
    const impersonationData = UserImpersonation.getImpersonationData();

    const originalUserId = impersonationData?.originalUserId?.toString() || 'null';

    const options = { domain: getMainAppDomain() };
    Cookies.set(LOCAL_STORAGE_KEYS.ORIGINAL_USER_ID, originalUserId, options);
  }

  static setImpersonationDataFromCookies() {
    const originalUserId = Cookies.get(LOCAL_STORAGE_KEYS.ORIGINAL_USER_ID);

    if (originalUserId) {

      if (originalUserId === 'null') {
        UserImpersonation.clearImpersonationData();
      } else {
        UserImpersonation.setImpersonationData(
          parseInt(originalUserId, 10),
        );
      }
    }
    this.clearImpersonationDataFromCookies();
  }

  static clearImpersonationDataFromCookies() {
    const options = { domain: getMainAppDomain() };
    Cookies.remove(LOCAL_STORAGE_KEYS.ORIGINAL_USER_ID, options);
  }

  static clearImpersonationData() {
    window.localStorage.removeItem(LOCAL_STORAGE_KEYS.ORIGINAL_USER_ID);
  }
}